import { render, staticRenderFns } from "./triggernav.vue?vue&type=template&id=710c0b36&scoped=true&"
import script from "./triggernav.vue?vue&type=script&lang=js&"
export * from "./triggernav.vue?vue&type=script&lang=js&"
import style0 from "./triggernav.vue?vue&type=style&index=0&id=710c0b36&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710c0b36",
  null
  
)

export default component.exports